<div class="p-20">
    <h2 mat-dialog-title>
        {{"PP.NEW_FOLDER.DIALOG.TITLE" | translate}}
    </h2>
    <form [formGroup]="newFolderForm" fxLayout="row wrap">

        <mat-form-field fxFlex="0 1 100" appearance="outline" floatLabel="always" class="m-8">
            <mat-label>
                {{ 'PP.NEW_FOLDER.DIALOG.INPUT.PLACEHOLDER' | translate }}
            </mat-label>
            <input matInput formControlName="nameFolder" autocomplete="off" class="mt-4"
                [maxlength]="textFiltersMaxLength">
        </mat-form-field>
    </form>
    <div fxLayout="row wrap" style="justify-content:end;gap: 10px;">
        <button mat-raised-button color="primary" class="my-8" (click)="onCancel()">
            {{"PP.NEW_FOLDER.DIALOG.BUTTONS.CANCEL" | translate}}
        </button>
        <button mat-raised-button color="secondary" class="my-8 px-8" (click)="onContinue()" [disabled]="newFolderForm.invalid">
            {{"PP.NEW_FOLDER.DIALOG.BUTTONS.CREATE" | translate}}
        </button>
    <div>
</div>